import TableSectionComponent, { type WordpressTableBlock } from 'content/Table';

export interface TableBlockProps {
    data: WordpressTableBlock;
}

const TableBlock: React.FunctionComponent<TableBlockProps> = ({ data }) => <TableSectionComponent {...data} />;

export default TableBlock;
